module.exports = __webpack_public_path__ + "img/add.40459afd.svg";